import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSizeDecimal',
  standalone: false
})
export class FileSizeDecimalPipe implements PipeTransform {
  transform(bytes: number, decimalPlaces = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1000;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const convertedValue = parseFloat((bytes / Math.pow(k, i)).toFixed(decimalPlaces));

    return `${convertedValue} ${sizes[i]}`;
  }
}
